module.exports = __webpack_public_path__ + "static/media/Triangle.89205900.svg";